import { type SocietyDashboardModuleViewWithDetails } from "shared/api/types/society/[societyId]/dashboards/[dashboardId]";
import { renderTemplateUtil } from "shared/components/template/renderTemplateUtil";
import { type CustomSessionType } from "shared/context/CustomSessionContext";
import { type WorkflowView } from "shared/mappers/database/workflow/workflow";
import { type WorkflowInstanceView } from "shared/mappers/database/workflow/workflow-instance";
import { type WorkflowActionUserHubEvaluation } from "shared/types/workflow";

type EvaluateWorkflowActionProps = {
  userHubEvaluation?: WorkflowActionUserHubEvaluation;
  workflowInstance?: WorkflowInstanceView;
  session: CustomSessionType;
  dashboardModulesData?: SocietyDashboardModuleViewWithDetails[];
  defaultEnabled?: boolean;
  baseClassName?: string;
  workflow?: WorkflowView;
};
export const evaluateWorkflowAction = (
  props: EvaluateWorkflowActionProps,
): {
  isActionEnabled: boolean;
  itemClassName: string;
} => {
  return {
    isActionEnabled: evaluateActionEnableState(props),
    itemClassName: evaluateClassName(props),
  };
};

const evaluateActionEnableState = ({
  userHubEvaluation,
  workflowInstance,
  session,
  dashboardModulesData,
  workflow,
  defaultEnabled = true,
}: EvaluateWorkflowActionProps): boolean => {
  if (
    session.adminMode ||
    userHubEvaluation === undefined ||
    userHubEvaluation.actionEnableEvaluation === undefined
  ) {
    return defaultEnabled;
  }
  const handleBarHtmlValue = renderTemplateUtil({
    template: userHubEvaluation?.actionEnableEvaluation,
    templateData: {
      session,
      workflow,
      workflowInstance,
      dashboardModulesData,
    },
  });

  console.log(workflow);
  return handleBarHtmlValue.toLowerCase().trim() === "true";
};

const evaluateClassName = ({
  userHubEvaluation,
  workflowInstance,
  workflow,
  session,
  dashboardModulesData,
  baseClassName = "",
}: EvaluateWorkflowActionProps): string => {
  if (
    session.adminMode ||
    userHubEvaluation === undefined ||
    userHubEvaluation.classNameEvaluation === undefined
  ) {
    return baseClassName;
  }
  const handleBarHtmlValue = renderTemplateUtil({
    template: userHubEvaluation?.classNameEvaluation,
    templateData: {
      session,
      workflowInstance,
      workflow,
      dashboardModulesData,
    },
  });
  if (handleBarHtmlValue.toLowerCase().trim() === "true") {
    return `${baseClassName} ${userHubEvaluation?.classNameTrue || ""}`.trim();
  }
  return `${baseClassName} ${userHubEvaluation?.classNameFalse || ""}`.trim();
};
